import { KeyboardDatePicker } from '@material-ui/pickers';
import React, { useRef } from 'react';

const CustomDateField = ({ field, form, meta, ...props }) => {
  const validationTimeoutRef = useRef();

  return (
    <KeyboardDatePicker
      inputVariant="outlined"
      emptyLabel=""
      cancelLabel="Voltar"
      invalidLabel=""
      invalidDateMessage="Favor informar uma data válida."
      maxDateMessage="Favor informar uma data válida."
      minDateMessage="Favor informar uma data válida."
      format="DD/MM/YYYY"

      InputLabelProps={{ shrink: true }}
      fullWidth
      name={field.name}
      value={field.value}
      onBlur={() => form.setFieldTouched(field.name)}
      onChange={(date) => {
        form.setFieldValue(field.name, date);

        if (Boolean(validationTimeoutRef.current)) {
          clearTimeout(validationTimeoutRef.current);
        }

        validationTimeoutRef.current = setTimeout(() => form.setFieldTouched(field.name), 350);
      }}
      error={Boolean(meta.error)}
      helperText={meta.error}
      {...props}
    />
  );
};

export default CustomDateField;
